"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _chunk5TCNBCB6js = require('./chunk-5TCNBCB6.js');











var _chunk52ALM2Y4js = require('./chunk-52ALM2Y4.js');

// src/react/ScopeProvider.tsx
var _react = require('react'); var _react2 = _interopRequireDefault(_react);

// src/react/contexts/ScopeContext.tsx

var ScopeContext = _react2.default.createContext([]);
ScopeContext.displayName = "BunshiMoleculeScopeContext";

// src/react/useScopes.tsx


// src/react/internal/flattenTuples.tsx
function flattenTuples(tuples) {
  return tuples.flatMap((t) => t);
}

// src/react/useInjector.tsx


// src/react/contexts/InjectorContext.tsx

var InjectorContext = _react2.default.createContext(() => _chunk52ALM2Y4js.getDefaultInjector.call(void 0, ));
InjectorContext.displayName = "BunshiMoleculeInjectorContext";

// src/react/useInjector.tsx
function useInjector() {
  return _react.useContext.call(void 0, InjectorContext)();
}

// src/react/useScopes.tsx
function useScopes(options) {
  const inputTuples = useScopeTuplesRaw(options);
  const injector = useInjector();
  const flattened = flattenTuples(inputTuples);
  const sub = _react.useMemo.call(void 0, () => {
    const innerSub = injector.createSubscription();
    innerSub.expand(inputTuples);
    return innerSub;
  }, [injector, ...flattened]);
  const [tuples, setTuples] = _react.useState.call(void 0, sub.tuples);
  _react.useEffect.call(void 0, () => {
    const subbedTuples = sub.start();
    setTuples(subbedTuples);
    return () => {
      sub.stop();
    };
  }, [sub, setTuples]);
  return tuples;
}
function useScopeTuplesRaw(options) {
  const parentScopes = _react.useContext.call(void 0, ScopeContext);
  const generatedValue = _react.useMemo.call(void 0, 
    () => new Error("Do not use this scope value. It is a placeholder only."),
    []
  );
  const componentScopeTuple = _react.useRef.call(void 0, [_chunk52ALM2Y4js.ComponentScope, generatedValue]).current;
  const inputTuples = (() => {
    if (!options)
      return [...parentScopes, componentScopeTuple];
    if (options.withUniqueScope) {
      return _chunk5TCNBCB6js.dstream.call(void 0, 
        _chunk5TCNBCB6js.dstream.call(void 0, parentScopes, [
          options.withUniqueScope,
          generatedValue
        ]),
        componentScopeTuple
      );
    }
    if (options.withScope) {
      return _chunk5TCNBCB6js.dstream.call(void 0, 
        _chunk5TCNBCB6js.dstream.call(void 0, parentScopes, options.withScope),
        componentScopeTuple
      );
    }
    if (options.exclusiveScope) {
      return [options.exclusiveScope, componentScopeTuple];
    }
    return [...parentScopes, componentScopeTuple];
  })();
  return inputTuples;
}

// src/react/ScopeProvider.tsx
function ScopeProvider(props) {
  const { value, scope, uniqueValue } = props;
  let options;
  if (uniqueValue) {
    options = {
      withUniqueScope: scope
    };
  } else {
    options = {
      withScope: [scope, value]
    };
  }
  const simpleDownstreamScopes = useScopes(options);
  const downstreamScopes = _react.useMemo.call(void 0, 
    () => simpleDownstreamScopes.filter(([scope2]) => scope2 !== _chunk52ALM2Y4js.ComponentScope),
    [simpleDownstreamScopes, scope]
  );
  return _react2.default.createElement(
    ScopeContext.Provider,
    { value: downstreamScopes },
    props.children
  );
}

// src/react/useMolecule.tsx

function useMolecule(mol, options) {
  const injector = useInjector();
  const inputTuples = useScopeTuplesRaw(options);
  const [value, handle] = _react.useMemo.call(void 0, () => {
    return injector.useLazily(mol, ...inputTuples);
  }, [
    mol,
    injector,
    /**
     * Tuple flattening prevents re-renders unless the number of
     */
    ...flattenTuples(inputTuples)
  ]);
  const [mutableValue, setMutableValue] = _react.useState.call(void 0, () => value);
  _react.useEffect.call(void 0, () => {
    const subbedValue = handle.start();
    setMutableValue(() => subbedValue);
    return () => {
      handle.stop();
    };
  }, [handle]);
  return mutableValue;
}

// src/react/InjectorProvider.tsx
var InjectorProvider = InjectorContext.Provider;
















exports.ComponentScope = _chunk52ALM2Y4js.ComponentScope; exports.InjectorProvider = InjectorProvider; exports.ScopeProvider = ScopeProvider; exports.createInjector = _chunk52ALM2Y4js.createInjector; exports.createScope = _chunk52ALM2Y4js.createScope; exports.getDefaultInjector = _chunk52ALM2Y4js.getDefaultInjector; exports.molecule = _chunk52ALM2Y4js.molecule; exports.moleculeInterface = _chunk52ALM2Y4js.moleculeInterface; exports.onMount = _chunk52ALM2Y4js.onMount; exports.onUnmount = _chunk52ALM2Y4js.onUnmount; exports.resetDefaultInjector = _chunk52ALM2Y4js.resetDefaultInjector; exports.use = _chunk52ALM2Y4js.use; exports.useInjector = useInjector; exports.useMolecule = useMolecule; exports.useScopes = useScopes;
